import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "nz_lang";

export const detectLanguage = () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === "it" || saved === "en") return saved;
  const device = (navigator.language || "it").toLowerCase();
  return device.startsWith("it") ? "it" : "en";
};

export const useLanguage = () => {
  const [lang, setLang] = useState(detectLanguage);
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const change = useCallback((next) => { localStorage.setItem(STORAGE_KEY, next); setLang(next); }, []);
  return [lang, change];
};

export const STRINGS = {
  it: {
    skipToMenu: "Vai al menu",
    tabCucina: "Ristorante",
    tabBevande: "Bevande",
    tabPizze: "Pizzeria",
    tabVini: "I vini",
    captionCucina: "Il menu del ristorante",
    captionBevande: "Il menu delle bevande",
    captionPizze: "Il menu delle pizze",
    captionVini: "La carta dei vini",
    countCucina: "proposte",
    countBevande: "bevande",
    countPizze: "pizze",
    countVini: "etichette",
    coverCharge: "Coperto",
    perKg: "al kg",
    loadingMenu: "Caricamento menu",
    errorTitle: "Il menu non è al momento disponibile",
    errorBody: "Non siamo riusciti a caricarlo. Riprova oppure chiedi al personale di sala.",
    retry: "Riprova",
    emptyTitle: "Stiamo aggiornando il menu",
    emptyBody: "Per le proposte disponibili, chiedi al personale di sala.",
    refreshMenu: "Aggiorna menu",
    adminArea: "Amministrazione",
    allergenButton: "Elenco allergeni",
    allergenTitle: "Elenco allergeni",
    allergenSubtitle: "I 14 allergeni indicati dal Regolamento UE 1169/2011.",
    allergenNote: "Se soffri di allergie od intolleranze alimentari segnalalo al nostro personale che saprà metterti in condizione di evitare i generi che contengono prodotti ai quali sei allergico od intollerante.",
    languageLabel: "Lingua del menu",
    pizzaHeading: "Le nostre pizze",
    chefHeadingAlt: "Le proposte del nostro chef",
    drinksHeadingAlt: "Le nostre bevande",
    wineHeadingAlt: "La nostra selezione",
    switchToEnglish: "Switch to English",
    switchToItalian: "Passa all’italiano",
    noSubcategory: "",
  },
  en: {
    skipToMenu: "Skip to menu",
    tabCucina: "Restaurant",
    tabBevande: "Drinks",
    tabPizze: "Pizzeria",
    tabVini: "Wines",
    captionCucina: "The restaurant menu",
    captionBevande: "The drinks menu",
    captionPizze: "The pizza menu",
    captionVini: "The wine list",
    countCucina: "dishes",
    countBevande: "drinks",
    countPizze: "pizzas",
    countVini: "labels",
    coverCharge: "Cover charge",
    perKg: "per kg",
    loadingMenu: "Loading menu",
    errorTitle: "The menu is not available right now",
    errorBody: "We could not load it. Please try again or ask our staff.",
    retry: "Try again",
    emptyTitle: "We are updating the menu",
    emptyBody: "Please ask our staff about today’s dishes.",
    refreshMenu: "Refresh menu",
    adminArea: "Admin area",
    allergenButton: "Allergen list",
    allergenTitle: "Allergen list",
    allergenSubtitle: "The 14 allergens listed in EU Regulation 1169/2011.",
    allergenNote: "If you suffer from food allergies or intolerances, please tell our staff: they will help you avoid any dish containing products you are allergic or intolerant to.",
    languageLabel: "Menu language",
    pizzaHeading: "Our pizzas",
    chefHeadingAlt: "Our chef’s selection",
    drinksHeadingAlt: "Our drinks",
    wineHeadingAlt: "Our selection",
    switchToEnglish: "Switch to English",
    switchToItalian: "Passa all’italiano",
    noSubcategory: "",
  },
};

export const useStrings = (lang) => STRINGS[lang] || STRINGS.it;

export const makeTranslator = (lang, map) => (key, fallback) => {
  if (lang !== "en") return fallback;
  const text = map?.[key];
  return text && text.trim() ? text : fallback;
};
